import React, { useState, useEffect, useRef } from 'react';
import { Box, Flex, Title, Text, Space } from '@mantine/core';
import { primaryColor, ForeColorPurple, ForeColorYellow } from '../../lib/constants';
import OtherServicesCarousel from './otherServicesCarousel';
import { useWindowScroll, useMediaQuery } from '@mantine/hooks';

function OtherServices() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const isMobile = useMediaQuery('(max-width: 768px)');

  // Carousel auto-rotate
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 2);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  // Fade-in on scroll
  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(node);

    if (node.getBoundingClientRect().top < window.innerHeight * 0.8) {
      setVisible(true);
      observer.disconnect();
    }

    return () => observer.disconnect();
  }, []);

  const handleSlideChange = (index) => {
    setActiveIndex(index);
  };

  const renderIndicators = () => {
    return Array.from({ length: 2 }, (_, index) => (
      <div
        key={index}
        style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: index === activeIndex ? ForeColorYellow : '#ccc',
          margin: '0 5px',
          cursor: 'pointer',
        }}
        onClick={() => handleSlideChange(index)}
      />
    ));
  };

  return (
    <Box id="otherServices" mt={isMobile ? 60 : 200}>
      <Flex
        direction={isMobile ? 'column' : 'row'}
        align="stretch"
        justify="center"
        w="100%"
      >
        {/* Left: Carousel — desktop only */}
        {!isMobile && (
          <Box w="52vw" h="80vh">
            <OtherServicesCarousel activeIndex={activeIndex} style={{ zIndex: 1 }} />
          </Box>
        )}

        {/* Right / Bottom: Mission Text */}
        <Box
          ref={sectionRef}
          className={visible ? 'fade-text delay-0' : 'text-hidden'}
          w="100%"
          mih={isMobile ? "auto" : "80vh"}
          bg={ForeColorPurple}
          p={isMobile ? 24 : 50}
        >
          <Title
            style={{
              fontWeight: 500,
              color: primaryColor,
              fontSize: isMobile ? '24px' : '36px',
              marginBottom: isMobile ? 20 : 40,
            }}
          >
            Our Mission
          </Title>

          <Text
            mb={20}
            style={{
              fontWeight: activeIndex === 0 ? 700 : 500,
              fontSize: isMobile ? '20px' : '28px',
              color: primaryColor,
              cursor: 'pointer',
            }}
            onClick={() => handleSlideChange(0)}
          >
            Our Mission
          </Text>
          <Text
            className="Os-content"
            style={{
              fontWeight: 500,
              color: primaryColor,
              fontSize: isMobile ? 14 : 16,
            }}
          >
            To operate a growing chain of lodging facilities profitably throughout the Philippines by exceeding guest expectations and earning their loyalty through excellent accommodations and superior service, executed by a unified team of passionate professionals.
          </Text>

          <Space h={isMobile ? 30 : 50} />

          <Text
            mb={20}
            style={{
              fontWeight: activeIndex === 0 ? 700 : 500,
              fontSize: isMobile ? '20px' : '28px',
              color: primaryColor,
              cursor: 'pointer',
            }}
            onClick={() => handleSlideChange(0)}
          >
            Our Long-Term Goal
          </Text>
          <Text
            className="Os-content"
            style={{
              fontWeight: 500,
              color: primaryColor,
              fontSize: isMobile ? 14 : 16,
            }}
          >
            To lead and dominate the Philippine lodging industry by continuously innovating, expanding our hotel brands, and delivering unmatched service quality that resonates with every market segment we serve.
          </Text>
        </Box>
      </Flex>

      {/* Animation CSS */}
      <style>
        {`
          .fade-text {
            opacity: 1;
            transform: translateY(0);
            transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          }

          .text-hidden {
            opacity: 0;
            transform: translateY(30px);
          }

          .delay-0 {
            transition-delay: 0.2s;
          }
        `}
      </style>
    </Box>
  );
}

export default OtherServices;
